<template>
  <div
    class="filterGroup"
    v-bind:class="{ open: isOpen, collapsable: hasChilds }"
  >
    <h5 v-on:click="toogleCollapse">
      {{ config.text }} <span
        class="site-menu-arrow"
        v-if="hasChilds"
      ></span>
    </h5>

    <ul
      class="filter-list"
      v-if="isOpen"
    >
      <dep-filter-select
        v-if="config.type == 'select'"
        :select-options="config.selectOptions"
        :childs="childs"
        :moduleName="moduleName"
        :groupName="name"
        :placeholder="config.placeholder"
      ></dep-filter-select>
      <template v-else-if="config.mode == 'always-one' || config.type == 'radio'">
        <dep-filter-radio
          v-for="child in childs"
          :key="child.name"
          v-bind:option="child"
          :moduleName="moduleName"
          :groupName="name"
        ></dep-filter-radio>
      </template>
      <template v-else>
        <dep-filter-input
          v-for="child in childs"
          :key="child.name"
          v-bind:option="child"
          :moduleName="moduleName"
          :groupName="name"
        ></dep-filter-input>
      </template>
    </ul>
  </div>
</template>

<script>
import depFilterInput from "@/components/global/depFilterInput";
import depFilterRadio from "@/components/global/depFilterRadio";
import depFilterSelect from "@/components/global/depFilterSelect";

export default {
  components: { depFilterInput, depFilterSelect, depFilterRadio },
  props: ["config", "moduleName"],
  data: function () {
    return { isOpen: true };
  },
  computed: {
    selected() {
      return this.$store.state[this.moduleName].filters.filtersSelection[
        this.name
      ];
    },
    name: function () {
      return this.config.name;
    },
    hasChilds: function () {
      return this.childs.length > 0 && this.config.type != "select";
    },
    isCollapsable: function () {
      return this.hasChilds;
    },
    childs: function () {
      if (!this.config.childs) {
        return [];
      }

      var config = this.config;
      //si no se compacta regresa childs como está
      if (!config.compactBy)
        return config.childs.filter((item) => item !== null);

      var result = [];
      //Si se compacta compacta las opciones por nombre u otra propiedad
      for (var i = 0; i < config.childs.length; i++) {
        var ids = result.map((o) => {
          return o[config.compactBy];
        });
        var obj = Object.assign({}, config.childs[i]);
        var index = ids.indexOf(obj[config.compactBy]);

        if (index > -1) {
          result[index].id.push(obj.id);
        } else {
          if (!Array.isArray(obj.id)) obj.id = [obj.id];

          result.push(obj);
        }
      }

      return result.filter(
        (item) =>
          item.id && item.id.some((id) => id !== null && id !== undefined)
      );
    },
  },
  methods: {
    toogleCollapse: function () {
      if (this.hasChilds) this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style>
.filterGroup h5 {
  margin: 0;
  padding: 18px 0 0; /*10px;*/
  position: relative;
}
.filterGroup.collapsable h5 {
  cursor: pointer;
}
.filterGroup .site-menu-arrow {
  right: 0;
}
.filterGroup .site-menu-arrow:before {
  font-size: 10px;
  font-weight: normal;
  color: #76838f;
}
.filterGroup.open .site-menu-arrow {
  transform: rotate(90deg);
}
</style>
